<script>
import { computed, defineComponent } from '@vue/composition-api';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';

export default defineComponent({
  setup(props, { root }) {
    const profile = computed(() => root.$store.getters.getProfile);
    const {
      storeSelected,
      changeStoreSelected,
    } = useManagerDashboard();
    const { stores: sellerStores, loading: loadingStores } = useVuexSellerStores(root);

    return {
      storeSelected,
      changeStoreSelected,
      sellerStores,
      loadingStores,
      profile,
    };
  },
});
</script>

<template>
  <div class="header">
    <v-layout
      row
      justify-space-between
      align-center
      :class="{ 'mb-2': profile.cannotCreateUser }"
    >
      <TitleChip title="Gestão de Usuários" />
      <v-btn
        v-if="!profile.cannotCreateUser"
        fab
        small
        flat
        style="background-color: #FFADDE"
        :to="`/sellers/new`"
      >
        <v-icon small>
          $vuetify.icons.userPlusIcon
        </v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>
